/**
 * AJA Cart Auto Refresh — Stiletto + AppHero (Aja Box) uyumu
 * -----------------------------------------------------------------
 * AppHero hediye ekledikten sonra quick cart güncellenir.
 * Dikkat: Her /cart/* isteğinde anında refresh, AppHero'nun ikinci
 * isteğiyle üst üste tam sepet yenilemesine yol açar (yavaşlık).
 *
 * Çözüm: debounce + Stiletto cart:item-added sonrası bekleme +
 * refresh cooldown + visibilitychange kaldırıldı.
 *
 * Event: apps:product-added-to-cart
 * https://help.fluorescent.co/stiletto/for-developers/custom-javascript-events
 */
(function () {
  if (window.__ajaStilettoCartRefreshInstalled) return;
  window.__ajaStilettoCartRefreshInstalled = true;

  var script =
    document.currentScript ||
    document.querySelector('script[src*="aja-cart-auto-refresh"]');
  var debug = script && script.dataset && script.dataset.debug === 'true';
  if (script && script.dataset && script.dataset.enabled === 'false') {
    return;
  }

  var CART_PATTERN = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/i;
  var DEBOUNCE_BASE_MS = 120;
  var DEBOUNCE_AFTER_STILETTO_MS = 520;
  var REFRESH_COOLDOWN_MS = 900;
  var STILETTO_RECENT_MS = 400;

  var refreshTimer = null;
  var lastStilettoCartEvent = 0;
  var lastRefreshAt = 0;
  var pendingReason = '';

  function log() {
    if (!debug) return;
    var args = ['[AJA Cart Refresh]'].concat([].slice.call(arguments));
    console.log.apply(console, args);
  }

  function shouldWatch(url) {
    if (!url) return false;
    try {
      var u = typeof url === 'string' ? url : url.url || url.toString();
      return CART_PATTERN.test(u);
    } catch (e) {
      return false;
    }
  }

  function dispatchStilettoRefresh() {
    var now = Date.now();
    if (now - lastRefreshAt < REFRESH_COOLDOWN_MS) {
      log('Skipped refresh (cooldown)', pendingReason);
      return;
    }
    lastRefreshAt = now;
    log('Dispatching apps:product-added-to-cart', pendingReason);
    try {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    } catch (e) {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('apps:product-added-to-cart', true, true, null);
      document.dispatchEvent(evt);
    }
  }

  function scheduleRefresh(reason) {
    pendingReason = reason;
    clearTimeout(refreshTimer);

    var delay = DEBOUNCE_BASE_MS;
    if (Date.now() - lastStilettoCartEvent < STILETTO_RECENT_MS) {
      delay = DEBOUNCE_AFTER_STILETTO_MS;
    }

    log('Cart change queued:', reason, 'delay=' + delay + 'ms');
    refreshTimer = setTimeout(dispatchStilettoRefresh, delay);
  }

  document.addEventListener(
    'cart:item-added',
    function () {
      lastStilettoCartEvent = Date.now();
      log('cart:item-added (Stiletto — AppHero için bekleniyor)');
    },
    true
  );

  document.addEventListener('cart:updated', function () {
    log('cart:updated (Stiletto)');
  });

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var watch = shouldWatch(url);
      var result = originalFetch.apply(this, args);
      if (watch) {
        var u = typeof url === 'string' ? url : url.url || '';
        result
          .then(function () {
            scheduleRefresh('fetch ' + u);
          })
          .catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.__ajaCartWatch = shouldWatch(url);
      this.__ajaUrl = url;
    } catch (e) {}
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__ajaCartWatch) {
      xhr.addEventListener('load', function () {
        scheduleRefresh('xhr ' + xhr.__ajaUrl);
      });
    }
    return originalSend.apply(this, arguments);
  };

  log('Installed v2 (coalesced refresh for AppHero)');
})();
